/* eslint-disable */
import React, { useContext, useState, useEffect, useRef, useMemo } from 'react';
import {
  Grid,
  Typography,
  RACButton,
  RACTextbox,
  RACSelect,
  RACDatePicker,
  RACTooltip,
  RACModalCard,
  RACMUIDatePicker
} from '@rentacenter/racstrap';
import { useHistory, useParams } from 'react-router-dom';
import { dofStyles } from '../JSStyles/dofStyles';
import { ReactComponent as Info } from '../images/info-tooltip.svg';
import DOFHeader from './Header';
import { IdentityContext } from '../context/userInformation/IdentityContextProvider';
import { CreateCustomerStg, UpdateCustomer } from '../api/user';
import ScreenLoader from '../common/loader/ScreenLoader';
import BreadCrumb from './BreadCrumb';
import { useTranslation } from 'react-i18next';
import { ReactComponent as PdfIcon } from './../images/pdf-icon.svg';
import { ACCEPTED_FILE_TYPES, SIZE_UNIT_GB, SIZE_UNIT_KB, SIZE_UNIT_MB } from '../constants/constants';

import FileToPDFViewer from '../common/FileToPDFViewer';
import MessagePopup from '../common/MessagePopup';
import { handleFile, uploadDocuments, getBase64Size, compressBase64Image } from '../common/helperFunction/HelperFunction';
import { loadIDValidationScript } from '../common/IDValidationLibLoad';
import axios from 'axios';
import { IdentityInterface, StgIdentityRecord, StgCustomerResponse, CreateCustomerStgResponse, UpdateCustomerPayload, isStgSuccessResponse } from '../interface/CustomerInformationInterface';
import { getDateFormat } from '../utils/dateUtils';
import { NAAT_ERROR_MESSAGES } from '../utils/naatUtils';
import { formatByNumeric, formatPhoneNumber, validateNameField, convertToBase64 } from '../utils/identityUtils';
import { IDENTITY_DOC_SIDE as DOC_SIDE, IDENTITY_TAB_STEPS as STEPS, IDENTITY_MIN_DATE as MIN_DATE } from '../constants/constants';
import { useNAATResultHandlers } from '../common/hooks/useNAATResultHandlers';

interface Option {
  label: string;
  value: string;
}

const Identity: React.FC = () => {
  const frontFileInputRef = useRef<any>(null);
  const backFileInputRef = useRef<any>(null);
  const { t } = useTranslation();
  const sessionStorageValues = useMemo(
    () => JSON.parse(window.sessionStorage.getItem('dofAuthValues') || 'null'),
    []
  );
  const context = useContext(IdentityContext);
  if (!context) {
    return <div> {t("Application is not available")}</div>;
  }
  const {
    identityInformation,
    setIdentityInformation,
    genderDropOptions,
    maritalStatusDropOptions,
    racPromotionDropOptions,
    setStgCustomerProfileId,
    stgCustomerIdentityId,
    SetStgCustomerIdentityId,
    stgCustomerProfileId,
    detailSave,
    setDetailSave,
    otpSave,
    identityFrontDocument,
    setIdentityFrontDocument,
    identityBackDocument,
    setIdentityBackDocument,
    isIdentityFrontDocDeleted,
    setIsIdentityFrontDocDeleted,
    isIdentityBackDocDeleted,
    setIsIdentityBackDocDeleted,
    setFrontFileType,
    setBackFileType,
    frontFileSize,
    setFrontFileSize,
    backFileSize,
    setBackFileSize,
    IDValidationEnable,
    setIDValidationEnable,
    countryCode,
    storeDetails,
    featureFlagDetails,
    getCustomerRes,
    liveLinessCheckEnable,
    setLiveLinessCheckEnable,
    getStgCustomerRes,
    setGetStgCustomerRes,
    setLiveLinessCompleted,
    customerId,
    secretValues,
    idValidationCompleted,
    setIdValidationCompleted,
  } = context;

  const classes = dofStyles();
  const history = useHistory();

  const isNextEnabled = useMemo(() => {
    const {
      firstName,
      paternalLastName,
      curp,
      ineVoterid,
      gender,
      dateOfBirth,
      maritalStatus,
      phoneNumber,
      emailId,
      racPromotions,
      rfc
    } = identityInformation;

    return (
      !!firstName &&
      !!paternalLastName &&
      !!curp &&
      !!ineVoterid &&
      !!gender &&
      !!dateOfBirth &&
      !!maritalStatus &&
      !!phoneNumber &&
      !!emailId &&
      !!racPromotions &&
      !!rfc &&
      !!identityFrontDocument &&
      !!identityBackDocument
    );
  }, [identityInformation, identityFrontDocument, identityBackDocument]);
  const [errorMessages, setErrorMessages] = useState<Record<string, string>>({});
  const [screenLoader, setScreenLoader] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [messagePopup, setMessagePopup] = useState<boolean>(false);
  const [showFrontDocument, setShowFrontDocument] = useState<boolean>(false);
  const [showBackDocument, setShowBackDocument] = useState<boolean>(false);
  const [openFrontDocument, setOpenFrontDocument] = useState<boolean>(false);
  const [openBackDocument, setOpenBackDocument] = useState<boolean>(false);
  const [base64Files, setBase64Files] = useState<string[]>([]);
  const [uploadedFiles, setUploadedFiles] = useState<File[]>([]);
  const [deepCloneIdentityInformation, setDeepCloneIdentityInformation] = useState<any>(JSON.parse(JSON.stringify(identityInformation)));
  const [initialIdentityFrontDocument, setInitialIdentityFrontDocument] = useState<File | null>(identityFrontDocument);
  const [initialIdentityBackDocument, setInitialIdentityBackDocument] = useState<File | null>(identityBackDocument);
  const [IDScriptsReady, setIDScriptsReady] = useState(false);
  const [tranId, setTranId] = useState<string>('');
  const hasTriggered = useRef<boolean>(false); // ref to avoid stale closure in async flows
  const selfieCallbackHandled = useRef<boolean>(false); // true when onSelfieVerificationComplete has already handled the result
  const [naatIDTrialsCount, setNaatIDTrialsCount] = useState(0);
  const [naatSelfieTrialsCount, setNaatSelfieTrialsCount] = useState(0);
  // Mirror ref so handleSelfieFailure can read the current count synchronously
  // without relying on a functional updater for side-effect logic.
  const naatSelfieTrialsCountRef = useRef<number>(0);

  // NAAT Error Handling State Variables
  const [naatErrorMessage, setNaatErrorMessage] = useState<string>('');
  const [showNaatErrorPopup, setShowNaatErrorPopup] = useState<boolean>(false);

  // Selfie Error Handling State Variables
  const [selfieErrorMessage, setSelfieErrorMessage] = useState<string>('');
  const [showSelfieErrorPopup, setShowSelfieErrorPopup] = useState<boolean>(false);
  const latestIdentityRecord = useMemo((): StgIdentityRecord | undefined => {
    const filtered: StgIdentityRecord[] = getStgCustomerRes?.identityInfo?.filter(
      (item: StgIdentityRecord) => item.livenessChecked === 0
    ) ?? [];

    const agreementFiltered: StgIdentityRecord[] = sessionStorageValues?.agreementId
      ? filtered.filter(
          (item: StgIdentityRecord) =>
            item.agreementId != null &&
            String(item.agreementId) === String(sessionStorageValues?.agreementId)
        )
      : [];
    const recordsToSearch: StgIdentityRecord[] =
      agreementFiltered.length > 0 ? agreementFiltered : filtered;

    return recordsToSearch?.reduce(
      (latest: StgIdentityRecord, current: StgIdentityRecord) =>
        new Date(current.transactionDate) > new Date(latest.transactionDate)
          ? current
          : latest,
      recordsToSearch[0]
    );
  }, [getStgCustomerRes, sessionStorageValues?.agreementId]);

  const [showLivenessCompletedPopup, setShowLivenessCompletedPopup] = useState<boolean>(false);

  const [originalIdentityInfo, setOriginalIdentityInfo] = useState<IdentityInterface>();

  const { canEnableCountryCode, enableSecondName, featureFlagDetail } = useMemo(() => {
    const raw = window.sessionStorage.getItem('featureFlagDetails');
    const flags: any[] = raw ? JSON.parse(raw) : [];
    return {
      featureFlagDetail: flags,
      canEnableCountryCode: flags.find((p: { paramKeyName: string }) => p.paramKeyName === 'CountryCode'),
      enableSecondName: flags.find((p: { paramKeyName: string }) => p.paramKeyName === 'MXStoreIdentifier'),
    };
  }, []);

  const reorderedOptions: Option[] = useMemo(() => [
    ...racPromotionDropOptions.filter((opt: Option) => opt.value.toLowerCase() !== 'other'),
    ...racPromotionDropOptions.filter((opt: Option) => opt.value.toLowerCase() === 'other'),
  ], [racPromotionDropOptions]);

  // Get date format based on store region
  const dateFormat = getDateFormat(storeDetails, featureFlagDetails);


  useEffect(() => {
    const hasFrontDocument = Boolean(identityFrontDocument);
    const hasBackDocument = Boolean(identityBackDocument);

    setShowFrontDocument?.(hasFrontDocument);
    setShowBackDocument?.(hasBackDocument);
  }, [identityBackDocument, identityFrontDocument, setShowBackDocument, setShowFrontDocument]);
  // Checks if liveness has already been completed for the agreement in the URL param.
  // Returns true only when: agreementId param exists AND a staging identity record
  // matches that agreementId AND livenessChecked === 1.
  // Returns false (proceed with normal flow) when: no agreementId param, or
  // no matching record, or the matching record has livenessChecked === 0.
  const validateLivenessCheckCompleted = (): boolean => {
    const agreementId: string | undefined = sessionStorageValues?.agreementId;
    if (!agreementId) return false;

    const matchingRecords = getStgCustomerRes?.identityInfo?.filter(
      (item: StgIdentityRecord) =>
        item.agreementId != null &&
        String(item.agreementId) === String(agreementId) &&
        item.livenessChecked === 1
    ) ?? [];

    return matchingRecords.length > 0;
  };


  // Script loading for NAAT/liveness — runs once getStgCustomerRes is populated
  // so validateLivenessCheckCompleted() has real data to check before the SDK loads.
  // For ID validation flow (no getStgCustomerRes dependency), still fires on mount.
  useEffect(() => {
    console.log('GetCustomerStaging Data', getStgCustomerRes)
    const enableLivenessParam = featureFlagDetail.find(
      (p: { paramKeyName: string }) => p.paramKeyName === 'EnableLivelinessCheck'
    );
    const shouldEnableLiveness =
      enableLivenessParam?.paramValue === '1' &&
      sessionStorageValues?.idDocType === 'SELF' &&
      sessionStorageValues?.otpVerifyReq !== 'Y';

    // For liveness flow: only proceed once getStgCustomerRes has loaded
    // so we can check if liveness was already completed before touching the SDK.
    if (shouldEnableLiveness) {
      // Wait until stg customer data is available
      if (!getStgCustomerRes || getStgCustomerRes === '') {
        console.log('[LIVENESS_INIT] Waiting for getStgCustomerRes to load...');
        return;
      }

      // Check if liveness already completed for this agreement — redirect immediately
      if (validateLivenessCheckCompleted()) {
        console.log('[LIVENESS_INIT] Already completed for this agreement — redirecting to submission');
        setLiveLinessCheckEnable(false);
        setScreenLoader(false);
        setLiveLinessCompleted(true);
        history.push('/submission');
        return;
      }
    }

    const effectiveLiveness = liveLinessCheckEnable || shouldEnableLiveness;

    if (
      (featureFlagDetails?.EnableIdValidation === '1' && IDValidationEnable && featureFlagDetails?.EnableManualIDUpload === '0') ||
      (featureFlagDetails?.EnableLivelinessCheck === '1' && effectiveLiveness)
    ) {
      if (shouldEnableLiveness && !liveLinessCheckEnable) {
        setLiveLinessCheckEnable(true);
      }
      setScreenLoader(true);
      console.log('[LIVENESS_INIT] Loading NAAT SDK script');

      const loadIDScriptFn = async () => {
        setScreenLoader(true);
        try {
          await loadIDValidationScript(secretValues);
          console.log('IdentityValidator is ready:', window.IdentityValidator);
          setIDScriptsReady(true);
        } catch (err) {
          console.error('Failed to load IdentityValidator:', err);
        }
      };
      loadIDScriptFn();
    }

    if (!originalIdentityInfo) {
      setOriginalIdentityInfo(identityInformation);
    }
  }, [getStgCustomerRes]);



  const observerRef = useRef<MutationObserver | null>(null); // kept for cleanup only, no longer used for triggering
  const NoOfNAATValidationTrials = featureFlagDetails?.NAATValidationNoOfTrials
    ? JSON.parse(featureFlagDetails.NAATValidationNoOfTrials)
    : { ID: 1, SELFIE: 1 };

  // NAAT Error Handler Function
  const handleNAATValidationError = (apiResult: any) => {
    const errorKey = apiResult?.key || 'UNKNOWN_ERROR';
    const message = NAAT_ERROR_MESSAGES[errorKey] || 'ID validation failed';
    
    setNaatErrorMessage(t(message));
    setShowNaatErrorPopup(true);
  };

  // Shared Selfie Failure Handler — all SDK failure paths funnel here.
  // Increments the trial counter, checks the configured limit, and either
  // shows the retry popup (if attempts remain) or navigates to the manual
  // selfie upload flow (when trials are exhausted).
  const handleSelfieFailure = (reason: string) => {
    console.log('[SELFIE_FAILURE] Reason:', reason);

    // Cleanup SDK state immediately on every failure
    hasTriggered.current = false;
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    document.querySelectorAll('fad-sdk').forEach((el) => el.remove());
    const selfieContainer = document.getElementById('selfie-button');
    if (selfieContainer) selfieContainer.innerHTML = '';
    setScreenLoader(false);
    setLiveLinessCheckEnable(false);

    // Compute next count from the ref (always current, no stale closure risk)
    // then update both the ref and the state as pure operations.
    const nextTrialCount = naatSelfieTrialsCountRef.current + 1;
    const hasTrialsRemaining = nextTrialCount < NoOfNAATValidationTrials.SELFIE;

    naatSelfieTrialsCountRef.current = nextTrialCount;
    setNaatSelfieTrialsCount(nextTrialCount); // pure — just syncs UI state

    console.log('[SELFIE_FAILURE] Trial check:', {
      previousTrial: nextTrialCount - 1,
      nextTrial: nextTrialCount,
      maxTrials: NoOfNAATValidationTrials.SELFIE,
      hasTrialsRemaining,
    });

    // Side effects are separate from the state update
    if (!hasTrialsRemaining) {
      // Trials exhausted (or disabled) — route to manual selfie upload flow
      console.log('[SELFIE_FAILURE] Trials exhausted, navigating to manual flow');
      if (NoOfNAATValidationTrials.SELFIE === 0) {
        history.push('/selfieupload');
      } else {
        history.push({
          pathname: '/livelinesscheck/failed',
          state: { errorMessage: t(reason) },
        });
      }
    } else {
      // Attempts remain — show retry popup
      console.log('[SELFIE_FAILURE] Showing retry popup');
      setSelfieErrorMessage(t(reason));
      setShowSelfieErrorPopup(true);
    }
  };

  // Selfie/Liveness Error Handler — delegates to shared failure handler
  const handleSelfieValidationError = (errorMessage: string) => {
    console.log('[SELFIE_VALIDATION_ERROR]', errorMessage);
    const isFaceCompareError = /Face Compare error: Face Compare failed:.*is not enough confidence/i.test(errorMessage);
    const reason = isFaceCompareError ? 'Face mismatch with INE photo' : 'Selfie validation failed';
    handleSelfieFailure(reason);
  };

  // Selfie Retry Handler — only runs when hasTrialsRemaining was true
  const handleRetrySelfieCapture = () => {
    console.log('[SELFIE_RETRY] Triggered:', { currentTrial: naatSelfieTrialsCount, maxTrials: NoOfNAATValidationTrials.SELFIE });
    setShowSelfieErrorPopup(false);
    setSelfieErrorMessage('');
    hasTriggered.current = false;
    setLiveLinessCheckEnable(true); // triggers useEffect → captureID
  };

  // NAAT Retry Handler Function
  const handleRetryCapture = () => {
    const nextTrialCount = naatIDTrialsCount + 1;
    const hasTrialsRemaining = nextTrialCount < NoOfNAATValidationTrials.ID;

    console.log('NAAT Retry triggered:', { currentTrial: naatIDTrialsCount, maxTrials: NoOfNAATValidationTrials.ID, willRetry: hasTrialsRemaining });

    setShowNaatErrorPopup(false);
    setNaatErrorMessage('');
    setNaatIDTrialsCount(nextTrialCount);

    if (hasTrialsRemaining) {
      setIDValidationEnable(true); // useEffect fires → captureID resets its own guard
    } else {
      console.log('NAAT Trials exhausted, falling back to manual upload');
      setIDValidationEnable(false);
    }
  };

  // 1. UseEffect for NAAT trigger & retry logic
  useEffect(() => {
    if (
      (featureFlagDetails?.EnableIdValidation === '1' &&
        IDValidationEnable &&
        featureFlagDetails?.EnableManualIDUpload === '0')
    ) {
      if (IDScriptsReady) {
        if (naatIDTrialsCount < NoOfNAATValidationTrials.ID) {
          console.log("captureid useeffect", naatIDTrialsCount, NoOfNAATValidationTrials.ID)
          setScreenLoader(true);
          captureID();
        } else {
          setScreenLoader(false);
          setIDValidationEnable(false); // Fallback to manual flow
        }
      }
    } else if (featureFlagDetails?.EnableLivelinessCheck === '1' && liveLinessCheckEnable) {
      if (IDScriptsReady) {
        if (naatSelfieTrialsCount < NoOfNAATValidationTrials.SELFIE) {
          console.log("captureselfie useeffect", naatSelfieTrialsCount, NoOfNAATValidationTrials.SELFIE)
          setScreenLoader(true);
          captureID();
        } else if (NoOfNAATValidationTrials.SELFIE === 0) {
          history.push(`/selfieupload`);
        } else {
          console.log("captureselfie useeffect - trials exhausted", naatSelfieTrialsCount, NoOfNAATValidationTrials.SELFIE, liveLinessCheckEnable)
          setScreenLoader(false);
          setLiveLinessCheckEnable(false);
          const fadSdkElements = document.querySelectorAll('fad-sdk');
          fadSdkElements.forEach((element) => {
            element.remove();
          });
          setTimeout(() => {
            if (!window.location.pathname.includes('/livelinesscheck/failed')) {
              history.push("/livelinesscheck/failed");
            }
          }, 0);
        }
      }
    }
  }, [
    IDScriptsReady,
    IDValidationEnable,
    liveLinessCheckEnable,
    naatIDTrialsCount,
    naatSelfieTrialsCount,
    featureFlagDetails,
  ]);

  // Handles the NAAT SDK capture-ID/selfie results — extracted into a custom
  // hook since the logic is largely self-contained and reads context state directly.
  const { readSdkResults, readSelfieVerificationData } = useNAATResultHandlers({
    setScreenLoader,
    setNaatIDTrialsCount,
    setTranId,
    hasTriggered,
    latestIdentityRecord,
    canEnableCountryCode,
    sessionStorageValues,
    onSelfieFailure: handleSelfieFailure,
  });

  const generateIdvsToken = async (): Promise<string> => {
    try {
      const { data } = await axios.post(
        secretValues?.idvsEndpoint,
        { api_key: secretValues?.idvsApiKey },
        {
          headers: {
            Accept: 'application/vnd.acima-v1+json',
            'Content-Type': 'application/json',
          },
        }
      );
      return data.token;
    } catch (error: unknown) {
      console.error('Error fetching IDVS token:', { status: error.response?.status, message: error.message });
      throw error;
    }
  };


  const captureID = async () => {
    // Guard: prevent multiple simultaneous invocations
    if (hasTriggered.current) {
      console.log("captureID already in progress, skipping duplicate call");
      return;
    }
    hasTriggered.current = true;
    // Reset the callback guard so the catch block doesn't suppress a genuine error
    // on this new invocation.
    selfieCallbackHandled.current = false;

    try {
      setScreenLoader(true);

      const generateToken = await generateIdvsToken();

      const IdentityValidator = (window as any).IdentityValidator;

      // Determine transactionId based on the idDocType query param (stored in sessionStorage):
      // - 'SELFIE': reuse the existing transactionGuid from the latest record so the SDK
      //             links the selfie to the already-created ID transaction.
      // - 'ID'    : always generate a fresh UUID so the SDK never returns a cached result
      //             on retry/cancel flows.
      // - anything else / undefined: do not send a transactionId.
      const idDocType: string | null = sessionStorageValues?.idDocType;


      const validator = new IdentityValidator({
        environment: secretValues?.environment || "sandbox",
        fadAppName: secretValues?.fadAppName || "rentaCenter",
        fadToken: secretValues?.fadToken,
        authToken: generateToken,
        captureIdContainerId: "capture-id-button",
        selfieVerificationContainerId: "selfie-button",
        businessUnit: "rac",
        // Use idDocType from the URL param (stored in sessionStorage) to determine
        // which transactionId to send — this is the most explicit signal of the flow:
        //   "SELF"  → liveness/selfie flow: pass the existing transactionGuid so the SDK
        //             links the selfie to the prior ID capture transaction (multiStep).
        //   "ID"    → ID validation flow: do not pass a transactionId so the SDK always
        //             starts a fresh transaction and never returns a cached result.
        transactionId: idDocType === 'SELF'
          ? (latestIdentityRecord?.transactionGuid || undefined)
          : undefined,
        customerGuid: crypto.randomUUID(),
        multiStep:true,


        // Handler when capture ID completes
        onCaptureIdComplete: async (result: any) => {
          setScreenLoader(true);
          setIDValidationEnable(false);
          console.log("[NAAT] onCaptureIdComplete:", result);

          // Check for successful completion
          if (result?.sdkResult?.event === "PROCESS_COMPLETED" && result?.apiResult?.transaction_id) {
            console.log("[NAAT] Capture successful");
            setIDValidationEnable(false);
            setScreenLoader(false);
            await readSdkResults(result.sdkResult, result.apiResult);
          }
          // Check for validation error in initiateResponse.error_message
          else if (result?.apiResult?.initiateResponse?.error_message) {
            const errorMsg = result.apiResult.initiateResponse.error_message;
            console.log("[NAAT] Validation error:", errorMsg);
            
            // Extract error key from message (e.g., "key" => "BLURRY")
            const keyMatch = errorMsg.match(/"key"\s*=>\s*"([^"]+)"/);
            const errorKey = keyMatch ? keyMatch[1] : 'UNKNOWN_ERROR';
            
            setScreenLoader(false);
            handleNAATValidationError({ key: errorKey });
          }
          // Generic retry for other failures — count already managed by handleRetryCapture
          else {
            console.log("[NAAT] No valid result, triggering retry");
            hasTriggered.current = false;
            setScreenLoader(false);
            setIDValidationEnable(true);
          }

        },

        // Handler when selfie verification completes
        onSelfieVerificationComplete: (result: any) => {
          console.log("[SELFIE_COMPLETE] Selfie verification result:", result);
          
          // Check for error in the result
          if (result?.apiResult?.error_message) {
            const errorMsg = result.apiResult.error_message;
            console.log("[SELFIE_COMPLETE] Error message found:", errorMsg);
            selfieCallbackHandled.current = true;
            setScreenLoader(false);
            handleSelfieValidationError(errorMsg);
          }
          else if (result && result?.apiResult && result?.apiResult?.images) {
            console.log("[SELFIE_COMPLETE] Success - images found, processing result");
            selfieCallbackHandled.current = true;
            readSelfieVerificationData(result);
          } else {
            // Cancel / no result / CACHED response — route through shared failure handler
            // so the trial limit is respected and manual flow is triggered when exhausted
            console.log('[SELFIE_COMPLETE] No result / cancelled / cached — delegating to handleSelfieFailure');
            // Mark as handled so the catch block doesn't double-increment the trial count
            selfieCallbackHandled.current = true;
            handleSelfieFailure(t('Selfie capture was cancelled. Please try again.'));
          }
        },
      });
      console.log("validator", validator);
      console.log("liveLinessCheckEnable", liveLinessCheckEnable);
      setScreenLoader(false);

      if (liveLinessCheckEnable) {
        await validator.renderSelfieVerification();
        // Hide the SDK-injected selfie button — we trigger it programmatically
        const selfieBtn = document.getElementById('idvjs-selfie-btn');
        if (selfieBtn) {
          selfieBtn.style.display = 'none';
          selfieBtn.style.opacity = '0';
          selfieBtn.style.pointerEvents = 'none';
          selfieBtn.click();
        }
      } else {
        await validator.renderCaptureId();
        // Hide the SDK-injected capture button — we trigger it programmatically
        const captureBtn = document.getElementById('idvjs-capture-id-btn');
        if (captureBtn) {
          captureBtn.style.display = 'none';
          captureBtn.style.opacity = '0';
          captureBtn.style.pointerEvents = 'none';
          captureBtn.click();
        }
      }


    } catch (e: unknown) {
      console.log("Error in captureID Function", e);
      // Always stop the loader first — regardless of which path caused the error
      setScreenLoader(false);

      const isAxiosErr = axios.isAxiosError(e);
      const tokenUrl = secretValues?.idvsEndpoint;
      const isTokenError =
        isAxiosErr && (!e.response || e.response.status >= 400 || String(e.message).toLowerCase().includes('network')) && (!tokenUrl || e.config?.url === tokenUrl);
      if (
        (featureFlagDetails?.EnableIdValidation === '1' &&
          IDValidationEnable &&
          featureFlagDetails?.EnableManualIDUpload === '0')
      ) {
        if (isTokenError) {
          // IDVS token failed — fall back to manual ID upload immediately
          console.log("IDVS token generation failed (ID validation) — routing to manual upload");
          setIDValidationEnable(false);
          document.querySelectorAll('fad-sdk').forEach((el) => el.remove());
        } else {
          setNaatIDTrialsCount((count) => count + 1);
          setIDValidationEnable(true);
        }
      } else if (featureFlagDetails?.EnableLivelinessCheck === '1' && liveLinessCheckEnable) {
        if (isTokenError) {
          // IDVS token failed — fall back to manual selfie flow immediately
          console.log("IDVS token generation failed (liveness) — routing to manual flow");
          setLiveLinessCheckEnable(false);
          document.querySelectorAll('fad-sdk').forEach((el) => el.remove());
          history.push({
            pathname: '/livelinesscheck/failed',
            state: { errorMessage: t('Selfie verification is unavailable. Please upload a photo manually.') }
          });
        } else {
          // Only call handleSelfieFailure if the SDK callback hasn't already handled
          // this failure. When the user cancels, onSelfieVerificationComplete fires
          // AND renderSelfieVerification() may also throw/reject — without this guard
          // the trial count gets double-incremented per cancel.
          if (!selfieCallbackHandled.current) {
            handleSelfieFailure(t('Selfie capture failed. Please try again.'));
          }
        }
      }
    } finally {
      // Always reset guard to allow future retry attempts
      hasTriggered.current = false;
    }
  };

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
    filedName?: string
  ) => {
    const { name, value } = event.target;
    const key = filedName ? filedName : name;

    if (key === 'phoneNumber') {
      const numericValue = value.replace(/\D/g, ''); // Remove non-numeric characters
      if (numericValue.length <= 18) {
        setIdentityInformation?.((prevState: any) => ({
          ...prevState,
          [key]: numericValue,
        }));
        setErrorMessages((prev) => ({ ...prev, [key]: '' }));
      }
      return; // Exit early for phone number handling
    }

    if (['curp', 'ineVoterid'].includes(key)) {
      const regex = /^[a-zA-Z0-9]*$/;
      if (!regex.test(value)) {
        return;
      }
    }
    const finalValue = ['curp', 'ineVoterid'].includes(key) ? value.toUpperCase() : value;
    if (key === 'curp') {
      const curpRegex = /^[A-Za-z]{4}\d{6}(?:[A-Za-z]{3}[A-Za-z0-9]{0,5})?$/;
      if (curpRegex.test(finalValue)) {
        const rfcValue = finalValue.substring(0, 10);
        setIdentityInformation?.((prevState: any) => ({
          ...prevState,
          rfc: rfcValue,
        }));
      }
    }
    setIdentityInformation?.((prevState: any) => ({
      ...prevState,
      [key]: finalValue,
    }));
    setErrorMessages((prev) => ({ ...prev, [key]: '' }));
  };

  const handleDateChange = (date: string) => {
    setIdentityInformation?.((prevState: any) => ({
      ...prevState,
      dateOfBirth: date,
    }));
  };
  const { maxDate, formattedMaxDate } = useMemo(() => {
    const today = new Date();
    const max = new Date(today);
    max.setFullYear(today.getFullYear() - 18);
    return { maxDate: max, formattedMaxDate: max.toISOString().split('T')[0] };
  }, []);
  const validateFields = () => {
    const {
      firstName,
      secondName,
      paternalLastName,
      maternalLastName,
      emailId,
      curp,
      ineVoterid,
      gender,
      dateOfBirth,
      maritalStatus,
      phoneNumber,
      racPromotions,
      rfc
    } = identityInformation;

    const newErrorMessages: Record<string, string> = {};

    // Validate name fields using helper
    validateNameField(firstName.replace(/\s+/g, ''), 'firstName', newErrorMessages, 'First Name');
    validateNameField(paternalLastName.replace(/\s+/g, ''), 'paternalLastName', newErrorMessages, 'Paternal Last Name');
    if (maternalLastName?.length) {

      validateNameField(maternalLastName.replace(/\s+/g, ''), 'maternalLastName', newErrorMessages, 'Maternal Last Name')
    }


    // CURP validation
    if (!curp || curp.length !== 18 || !/^[A-Za-z]{4}\d{6}[A-Za-z]{3}[A-Za-z0-9]{5}$/.test(curp)) {
      newErrorMessages.curp = 'CURP must be 18 characters and follow the specified format';
    }
    else if (!/^[A-Za-z0-9]+$/.test(curp)) {
      newErrorMessages.curp = 'Enter a valid CURP ID'
    }

    if (!emailId || !/^[a-zA-Z0-9À-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailId)) {
      newErrorMessages.emailId = 'Enter a Valid Email'
    }
    else if (!emailId || !/^(("[\wÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü\s-]+")|([\wÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü-]+(?:\.[\wÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü-]+)*))(@((?:[\wÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü-]+\.)*\w[\wÀ-ÖØ-öø-ÿÑñÁÉÍÓÚÜáéíóúü-]{0,66})\.([a-zA-Z]{2,6}(?:\.[a-zA-Z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i.test(emailId)) {
      newErrorMessages.emailId = 'In order for us to process your request, please enter another personal email address without a period before the @.'
    }
    // INE Voter ID validation
    if (
      !ineVoterid ||
      ineVoterid.length !== 18 || // Ensure the length is exactly 18
      !/^[A-Za-z]{6}\d{6}\d{2}[A-Za-z][A-Za-z0-9]{3}$/.test(ineVoterid)
    ) {
      newErrorMessages.ineVoterid = 'INE Voter ID must be valid';
    }
    else if (!/^[A-Za-z0-9]+$/.test(ineVoterid)) {
      newErrorMessages.ineVoterid = 'Enter a valid INE Voter ID'
    }

    if (!rfc || rfc.length < 10 || rfc.length > 13 || !/^[A-Za-z]{4}\d{6}[A-Za-z0-9]{0,3}$/.test(rfc)) {
      newErrorMessages.rfc = 'Enter a Valid RFC';
    }

    // Gender
    if (!gender) {
      newErrorMessages.gender = 'Gender is mandatory.';
    }

    // Date of Birth
    if (!dateOfBirth || new Date(dateOfBirth) > maxDate || new Date(dateOfBirth) < MIN_DATE) {
      newErrorMessages.dateOfBirth = 'Enter a valid Date of Birth';
    }

    // Marital Status
    if (!maritalStatus) {
      newErrorMessages.maritalStatus = 'Marital Status is mandatory.';
    }

    // Phone Number
    if (!phoneNumber || phoneNumber.replace(/\D/g, '').length < 10) {
      newErrorMessages.phoneNumber = 'Phone Number must be in valid format';
    }

    // RAC Promotions
    if (!racPromotions) {
      newErrorMessages.racPromotions = 'Mandatory.';
    }

    return newErrorMessages;
  };

  const processDocument = async (doc: File | string): Promise<any> => {
    if (!doc) return undefined;

    if (typeof doc === 'string') {
      const sizeInBytes = await getBase64Size(doc);

      // compressBase64Image only supports data URLs (data:image/jpeg|png;base64,...)
      if (
        sizeInBytes > 2 * 1024 * 1024 &&
        /^data:image\/(jpeg|png);base64,/.test(doc)
      ) {
        return await compressBase64Image(doc);
      }

      return doc;
    }

    return await handleFile(doc, 1 * 1024 * 1024);
  };

  const handleNextClick = async () => {
    try {
    setScreenLoader(true);
    console.log('Identity Deep clone ', JSON.stringify(deepCloneIdentityInformation));
    // Compare current identityInformation with deepCloneIdentityInformation

    const hasIdentityChanges = JSON.stringify(identityInformation) !== JSON.stringify(deepCloneIdentityInformation);

    // Compare documents
    const hasFrontDocChanged =
      (identityFrontDocument !== initialIdentityFrontDocument && // Check if different File or null
        (identityFrontDocument?.name !== initialIdentityFrontDocument?.name || // Compare file names
          identityFrontDocument?.size !== initialIdentityFrontDocument?.size)) || // Compare file sizes
      isIdentityFrontDocDeleted; // Check if front document was deleted

    const hasBackDocChanged =
      (identityBackDocument !== initialIdentityBackDocument && // Check if different File or null
        (identityBackDocument?.name !== initialIdentityBackDocument?.name || // Compare file names
          identityBackDocument?.size !== initialIdentityBackDocument?.size)) || // Compare file sizes
      isIdentityBackDocDeleted; // Check if back document was deleted


    const hasChanges = hasIdentityChanges || hasFrontDocChanged || hasBackDocChanged;
    if (otpSave && !hasChanges) {
      history.push('/residence');
      setScreenLoader(false);
      return;
    }
    if (!hasChanges && detailSave) {
      history.push('/authentication');
      setScreenLoader(false);
      return;
    }

    const validationErrors = validateFields();

    if (Object.keys(validationErrors).length > 0) {
      setScreenLoader(false);
      setErrorMessages(validationErrors);
      return;
    } else {
      setErrorMessages(validationErrors);
    }
    console.log(' conditon ', !Number(stgCustomerProfileId));


    // If no errors, proceed to the next step
    const idDocType: string | null = sessionStorageValues?.idDocType;
    const stgCustomerPayload = {

      ...(!Number(stgCustomerProfileId) && { enableStoreAction: true }),
      stgCustomerProfileId: Number(stgCustomerProfileId) ? stgCustomerProfileId : undefined,
      action: Number(stgCustomerProfileId) ? "UPD" : "CRT",
      firstName: identityInformation.firstName || '',
      middleInitial: identityInformation.secondName || '',
      lastName: identityInformation.paternalLastName || '',
      maternalLastName: identityInformation.maternalLastName || '',
      gender: identityInformation?.gender ? identityInformation?.gender.toUpperCase() : '',
      dob: identityInformation.dateOfBirth || '',
      maritalStatus: identityInformation.maritalStatus || '',
      phoneNumber: identityInformation.phoneNumber ? identityInformation.phoneNumber.replace(/\D/g, '') : '',
      countryCode: canEnableCountryCode?.paramValue === '1' ? identityInformation.countryCode : undefined,
      emailId: identityInformation.emailId || '',
      referralSources: identityInformation.racPromotions || '',
      phoneType: 'CELL',
      callTime: 'MORN',
      submittedDate: new Date().toISOString().split('T')[0],
      storeNumber: window.sessionStorage.getItem('storeNumber'),
      productCode: sessionStorageValues?.productCode || getStgCustomerRes?.productCode || undefined,
      customerCreatedSource: sessionStorageValues?.clientId || getStgCustomerRes?.customerSource || undefined,
      customerId: sessionStorageValues?.type === 'EC' ? sessionStorageValues?.identifier : undefined,
      consentDate: getStgCustomerRes?.consentDate || null,
      identityInfo: {
        stgCustomerIdentityId:
          sessionStorageValues?.idDocType === "ID"
            ? undefined
            : (Number(stgCustomerIdentityId)
                ? stgCustomerIdentityId
                : latestIdentityRecord?.stageCustomerIdentityId
                  ? String(latestIdentityRecord?.stageCustomerIdentityId)
                  : undefined),
        curpId: identityInformation.curp,
        voterId: identityInformation.ineVoterid,
        rfcId: identityInformation.rfc,
        transactionGuid: tranId
          ? tranId
          : (latestIdentityRecord?.transactionGuid ?? null),
        transactionDate: sessionStorageValues?.otpVerifyReq === 'Y' ? (latestIdentityRecord?.transactionDate || new Date().toISOString()) : new Date().toISOString(),
        livenessChecked: sessionStorageValues?.otpVerifyReq === 'Y' ? (latestIdentityRecord?.livenessChecked || 0) : 0,
        // Only carry forward identityVerificationStatus and idValidationType from the
        // previous record if NAAT was actually completed in this session (idValidationCompleted).
        // If the user is just editing fields without re-doing NAAT, preserve the existing
        // record's status only when we are updating that same record (stgCustomerIdentityId present).
        // Never copy APPROVED/NAAT status when creating a new identity record (no stgCustomerIdentityId).
        identityVerificationStatus: idValidationCompleted
          ? (latestIdentityRecord?.identityVerification === "APPROVED" && Number(stgCustomerProfileId) ? 'APPROVED' : 'PENDING')
          : (Number(stgCustomerIdentityId) || latestIdentityRecord?.stageCustomerIdentityId)
            ? (latestIdentityRecord?.identityVerification === "APPROVED" && Number(stgCustomerProfileId) ? 'APPROVED' : 'PENDING')
            : 'PENDING',
        idValidationType: idValidationCompleted
          ? 'NAAT'
          : (Number(stgCustomerIdentityId) || latestIdentityRecord?.stageCustomerIdentityId)
            ? (latestIdentityRecord?.idValidationType ?? 'MANUAL')
            : 'MANUAL',
        selfieValidationType: idDocType === 'SELF' && (Number(stgCustomerIdentityId) || latestIdentityRecord?.stageCustomerIdentityId)
          ? (latestIdentityRecord?.selfieValidationtType ?? null)
          : null,
        ...(idDocType === 'SELF' && sessionStorageValues?.agreementId
              ? { agreementId: sessionStorageValues.agreementId }
              : {}),
      },
    };

    // Update Customer Payload

    let updateCustomerPayload: UpdateCustomerPayload | null = null;
    if (sessionStorageValues?.type === 'EC') {
      updateCustomerPayload = {
        customerId: sessionStorageValues?.identifier || '',
        firstName: identityInformation.firstName,
        middleInitial: identityInformation.secondName || null,
        lastName: identityInformation.paternalLastName,
        maternalLastName: identityInformation.maternalLastName || '',
        gender: identityInformation.gender ? identityInformation.gender.toUpperCase() : '',
        dateOfBirth: identityInformation.dateOfBirth,
        maritalStatus: identityInformation.maritalStatus,
        phoneNumber: identityInformation.phoneNumber ? identityInformation.phoneNumber.replace(/\D/g, '') : '',
        countryCode: canEnableCountryCode?.paramValue === '1' ? identityInformation.countryCode : undefined,
        emailAddress: identityInformation.emailId,
        referralSource: identityInformation.racPromotions,
        taxId: identityInformation.rfc,
        taxIdType: 'RFCTAXID',
        phones: [
          {
            note: '',
            phoneType: 'CELL',
            callTime: 'MORN',
            phoneId: (getCustomerRes?.phones && getCustomerRes?.phones?.length > 0) ? getCustomerRes?.phones[0]?.phoneId : '',
            phoneNumber: identityInformation.phoneNumber ? identityInformation.phoneNumber.replace(/\D/g, '') : '',
            callTimeType: 'MORN',
            primary: 'Y',
            countryCode: identityInformation?.countryCode || 'US',
            active: 'Y',
          },
        ],
        ...(identityInformation.curp !== originalIdentityInfo?.curp && { curpId: identityInformation.curp }),
        ...(identityInformation.ineVoterid !== originalIdentityInfo?.ineVoterid && { voterId: identityInformation.ineVoterid }),
      };
    }

    console.log('Payload:', stgCustomerPayload);
    const isStoreCodeFlow = window.sessionStorage.getItem('authKey')?.length ? false : true;
    console.log('isStoreCodeFlow ', isStoreCodeFlow);
    const accessToken = isStoreCodeFlow ? window.sessionStorage.getItem('storeNumber') : window.sessionStorage.getItem('authKey');


    const response: CreateCustomerStgResponse[] = sessionStorageValues?.type !== 'EC' 
      ? await Promise.all([CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken)]) 
      : await Promise.all([CreateCustomerStg(stgCustomerPayload, isStoreCodeFlow, accessToken), UpdateCustomer(updateCustomerPayload, isStoreCodeFlow, accessToken)]);

    let documentFrontData;
    let documentBackData;
    let uploadDocResponse: any;
    if (response[0].status === 200) {
      if (identityBackDocument || identityFrontDocument) {
        if (identityFrontDocument) {
          documentFrontData = await processDocument(identityFrontDocument);
        }
        if (identityBackDocument) {
          documentBackData = await processDocument(identityBackDocument);
        }
      }
      // Check if customerId or tcid is valid
      const stgCusProfId = Number(stgCustomerProfileId) ? stgCustomerProfileId : response[0]?.data?.stgCustomerProfileId;
      console.log('documentBackData ', documentBackData)
      console.log('documentFrontData ', documentFrontData)
      if (stgCusProfId) {
        const documentsToUpload = [];

        // Check if documentFrontData exists and push to the array
        if (documentFrontData) {
          documentsToUpload.push({
            documentType: 'IDENTTYDOC',
            file: documentFrontData.base64String || documentFrontData,
          });
        }

        // Check if documentBackData exists and push to the array
        if (documentBackData) {
          documentsToUpload.push({
            documentType: 'IDENTITYBACK',
            file: documentBackData.base64String || documentBackData,
          });
        }

        // Call uploadDocuments with the filtered array
        console.log('documentsToUpload ', documentsToUpload);
        uploadDocResponse = await uploadDocuments(stgCusProfId, documentsToUpload, null);
        console.log('uploadDocResponse ', uploadDocResponse);
      } else {
        console.error('Both customerId and tcid are null or invalid.');
      }
      if (
        getStgCustomerRes?.consentDate
      ) {
        const inputDate = new Date(getStgCustomerRes.consentDate);
        const now = new Date();
        // Create bounds using setFullYear
        const lowerBound = new Date(now);
        lowerBound.setFullYear(now.getFullYear() - 3);

        const upperBound = new Date(now);
        upperBound.setFullYear(now.getFullYear() + 3);

        // Check if inputDate is within the range
        const isWithinThreeYears = inputDate >= lowerBound && inputDate <= upperBound;

        console.log(isWithinThreeYears); // Should return true
        if (isWithinThreeYears) {
          history.push('/residence');
          if (isStgSuccessResponse(response[0]?.data)) {
            setStgCustomerProfileId(response[0].data.stgCustomerProfileId);
            SetStgCustomerIdentityId(response[0].data.stgCustomerIdentityId ?? '');
            const currentDofAuth = JSON.parse(window.sessionStorage.getItem('dofAuthValues') || '{}');
            window.sessionStorage.setItem('dofAuthValues', JSON.stringify({ ...currentDofAuth, stgCustomerProfileId: response[0].data.stgCustomerProfileId }));
          }
          setScreenLoader(false);
          return
        }
      }
      if (isStgSuccessResponse(response[0]?.data)) {
        setStgCustomerProfileId(response[0].data.stgCustomerProfileId);
        SetStgCustomerIdentityId(response[0].data.stgCustomerIdentityId ?? '');
        const currentDofAuth = JSON.parse(window.sessionStorage.getItem('dofAuthValues') || '{}');
        window.sessionStorage.setItem('dofAuthValues', JSON.stringify({ ...currentDofAuth, stgCustomerProfileId: response[0].data.stgCustomerProfileId }));
      }
    }
    else if (response[0].data.errors?.[0]?.error === "curpId/voterId already exist") {
      setErrorMessage(t("The CURP ID or Voter ID already exists. Please verify the details or contact the store for additional details."))
      setMessagePopup(true)
    }
    else if (response[0].data.errors?.[0]?.error === "Customer profile already exist") {
      setErrorMessage(t("The customer profile already exists. Please contact the store for additional details"))
      setMessagePopup(true)
    }
    setDetailSave(true);
    if (((identityBackDocument || identityFrontDocument) && uploadDocResponse === 200) || (!identityBackDocument && !identityFrontDocument)) {
      history.push('/authentication');
      if (otpSave) {
        history.push('/residence');
      }
    } else if ((identityBackDocument || identityFrontDocument) && uploadDocResponse !== 200) {
      setErrorMessage(t('Document upload failed. Please try again with a smaller file.'));
      setMessagePopup(true);
    }

    setScreenLoader(false);
    } catch (e: unknown) {
      // Fix 4: Catch any unhandled error so the loader never gets stuck
      console.error('handleNextClick error:', e);
      setScreenLoader(false);
      setErrorMessage(t('Something went wrong'));
      setMessagePopup(true);
    }
  };
  //  checking the function
  const handleButtonClick = (docSide: string) => {
    if (docSide === 'F') {
      frontFileInputRef?.current?.click();
    } else {
      backFileInputRef?.current?.click();
    }
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>, docSide: string) => {
    const files = event.target.files;
    if (files) {
      handleFiles(Array.from(files), docSide);
    }
  };

  const handleFiles = async (files: File[], docSide: string) => {
    const validFiles = files.filter((file) =>
      ACCEPTED_FILE_TYPES.includes(file.type)
    );

    setUploadedFiles((prev) => [...prev, ...validFiles]);

    // Convert each file into a Base64 string
    const base64Promises = validFiles.map((file) => convertToBase64(file));
    const base64Results = await Promise.all(base64Promises);

    // Save Base64 results to state
    setBase64Files((prev) => [...prev, ...base64Results]);

    handleFileDetails(files, docSide);
  };

  const handleFileDetails = (files: any, docSide: string) => {
    const fileSizeInBytes = files[0].size;
    if (docSide === 'F') {
      setFrontFileType?.(files[0].type);
      setIdentityFrontDocument?.(files[0]);
    }
    else {
      setBackFileType?.(files[0].type);
      setIdentityBackDocument?.(files[0]);
    }
    let fileSize: any = fileSizeInBytes;
    let sizeUnit = 'bytes';

    if (fileSizeInBytes >= 1024) {
      fileSize = fileSizeInBytes / 1024;
      sizeUnit = SIZE_UNIT_KB;
    }

    if (fileSize >= 1024) {
      fileSize = fileSize / 1024;
      sizeUnit = SIZE_UNIT_MB;
    }

    if (fileSize >= 1024) {
      fileSize = fileSize / 1024;
      sizeUnit = SIZE_UNIT_GB;
    }

    fileSize = fileSize.toFixed(2);
    if (docSide === 'F') {
      setFrontFileSize?.(`${fileSize} ${sizeUnit}`);
    }
    else {
      setBackFileSize?.(`${fileSize} ${sizeUnit}`);
    }

    const isAcceptedType = ACCEPTED_FILE_TYPES.includes(files[0].type);
    // const isPdf = files[0].type === 'application/pdf';
    const fileSizeNumber = Number(fileSize);

    if (!isAcceptedType) {
      setMessagePopup(true);
      setErrorMessage(
        'Invalid file format. Please upload a PDF, JPEG, or PNG.'
      );

      if (docSide === 'F') {
        setIdentityFrontDocument?.('');
      }
      else {
        setIdentityBackDocument?.('');
      }
      return;
    }

    if (sizeUnit === SIZE_UNIT_KB) {
      if (docSide === 'F') {
        setShowFrontDocument?.(true);
      }
      if (docSide === 'B') {
        setShowBackDocument?.(true);
      }
      return;
    }

    if (sizeUnit === SIZE_UNIT_MB && fileSizeNumber >= 5) {
      setMessagePopup(true);
      setErrorMessage('Please upload a file smaller than 5MB.');
      if (docSide === 'F') {
        setIdentityFrontDocument?.('');
      }
      else {
        setIdentityBackDocument?.('');
      }
      return;
    }

    if (
      (sizeUnit === SIZE_UNIT_MB && fileSizeNumber > 20) ||
      sizeUnit === SIZE_UNIT_GB
    ) {
      setMessagePopup(true);
      setErrorMessage('Please upload a file smaller than 20MB.');
      if (docSide === 'F') {
        setIdentityFrontDocument?.('');
      }
      else {
        setIdentityBackDocument?.('');
      }
      return;
    }

    if (docSide === 'F') {
      setShowFrontDocument?.(true);
    }
    if (docSide === 'B') {
      setShowBackDocument?.(true);
    }
  };

  const pdfModelContent = (docSide: string) => {
    if (docSide === 'F') {
      return <FileToPDFViewer file={identityFrontDocument} />;
    } else {
      return <FileToPDFViewer file={identityBackDocument} />;
    }
  };


  return (
    <>
      {screenLoader ? <ScreenLoader /> : null}
      <DOFHeader
        identity={true}
        residence={true}
        income={false}
        reference={false}
        activeStep={"Income"}
      />

      {/* NAAT Error Popup Modal - Rendered outside conditional to show during any phase */}
      {showNaatErrorPopup && (
        <RACModalCard
          borderRadius="15px"
          closeIcon={false}
          isOpen={showNaatErrorPopup}
          maxWidth={'sm'}
          title={t("ID Validation Error")}
        >
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item>
              <Typography style={{ textAlign: 'center', paddingTop: '7px'}}>
                {naatErrorMessage}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: '15px' }}>
              <RACButton
                variant="contained"
                color="primary"
                onClick={handleRetryCapture}
                style={{ padding: '8px 20px' }}
              >
                {t("Retry")}
              </RACButton>
            </Grid>
          </Grid>
        </RACModalCard>
      )}

      {/* Selfie/Liveness Error Popup Modal */}
      {showSelfieErrorPopup && (
        <RACModalCard
          borderRadius="15px"
          closeIcon={false}
          isOpen={showSelfieErrorPopup}
          maxWidth={'sm'}
          title={t("Liveliness Check Error")}
        >
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item>
              <Typography style={{ textAlign: 'center', paddingTop: '7px'}}>
                {selfieErrorMessage}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: '15px' }}>
              <RACButton
                variant="contained"
                color="primary"
                onClick={handleRetrySelfieCapture}
                style={{ padding: '8px 20px' }}
              >
                {t("Retry")}
              </RACButton>
            </Grid>
          </Grid>
        </RACModalCard>
      )}

      {/* Liveness Already Completed Popup — shown when livenessChecked=1 is already
          stamped for this contract in the staging table */}
      {showLivenessCompletedPopup && (
        <RACModalCard
          borderRadius="15px"
          closeIcon={false}
          isOpen={showLivenessCompletedPopup}
          maxWidth={'sm'}
          title={t("Liveliness Check Completed")}
        >
          <Grid container direction="column" alignItems="center" spacing={2}>
            <Grid item>
              <Typography style={{ textAlign: 'center', paddingTop: '7px' }}>
                {t("The livenesscheck was previously performed please continue with the process")}
              </Typography>
            </Grid>
            <Grid item style={{ marginTop: '15px' }}>
              <RACButton
                variant="contained"
                color="primary"
                onClick={() => {
                  setShowLivenessCompletedPopup(false);
                  setLiveLinessCompleted(true);
                  history.push('/submission');
                }}
                style={{ padding: '8px 20px' }}
              >
                {t("OK")}
              </RACButton>
            </Grid>
          </Grid>
        </RACModalCard>
      )}

      {IDValidationEnable ? <div id='capture-id-button' >
      </div> : liveLinessCheckEnable ? <div id='selfie-button' >
      </div> :
        <>
          <BreadCrumb steps={STEPS} />
          {messagePopup ? (
            <MessagePopup
              value={{
                message: errorMessage,
                setFunction: setMessagePopup,
                cleanupFunction: setErrorMessage,
              }}
            />
          ) : null}

          <Grid className={classes.referenceContainer1}>
            <Grid className={classes.referenceSection}>
              <Grid className={classes.headingWidth}>
                <Typography className={classes.heading}>{t("Identity")}</Typography>
              </Grid>
              <Grid style={{ display: 'flex', padding: '10px ', backgroundColor: '#EBFBFF', marginTop: '19px' }}>
                <Info style={{ height: '15px', width: '20px' }} />
                <Typography style={{ marginLeft: '10px' }}>{t("Certain details have been prefilled as they were obtained through document scanning.")}</Typography>


              </Grid>
              <Grid container spacing={3} style={{ marginTop: '20px' }}>
                <Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("First Name")}
                    name="firstName"
                    value={identityInformation?.firstName}
                    required={true}
                    OnChange={handleInputChange}
                    errorMessage={t(errorMessages.firstName)}
                    maxlength={30}
                  />
                </Grid>
                {enableSecondName?.paramValue !== '1' ? (<Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("Second Name")}
                    name="secondName"
                    value={identityInformation?.secondName}
                    OnChange={handleInputChange}
                    maxlength={30}
                    errorMessage={t(errorMessages.secondName)}
                  />
                </Grid>) : (<></>)}
                <Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("Paternal Last Name")}
                    name="paternalLastName"
                    value={identityInformation?.paternalLastName}
                    required={true}
                    OnChange={handleInputChange}
                    errorMessage={t(errorMessages.paternalLastName)}
                    maxlength={30}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: '20px' }}>
                <Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("Maternal Last Name")}
                    name="maternalLastName"
                    value={identityInformation?.maternalLastName}
                    required={false}
                    OnChange={handleInputChange}
                    errorMessage={t(errorMessages.maternalLastName)}
                    maxlength={30}
                  />
                </Grid>
                <Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("CURP")}
                    name="curp"
                    value={identityInformation?.curp}
                    required={true}
                    OnChange={handleInputChange}
                    errorMessage={t(errorMessages.curp)}
                    maxlength={18}
                  />
                </Grid>
                <Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("INE Voter ID")}
                    name="ineVoterid"
                    value={identityInformation?.ineVoterid}
                    required={true}
                    OnChange={handleInputChange}
                    errorMessage={t(errorMessages.ineVoterid)}
                    maxlength={18}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: '20px' }}>
                <Grid md={4} item sm={12} xs={12}>
                  <RACSelect
                    required={true}
                    inputLabel={t('Gender')}
                    options={genderDropOptions}
                    name="gender"
                    defaultValue={identityInformation?.gender}
                    onChange={(event: any) => {
                      handleInputChange(event, 'gender');
                    }}
                    errorMessage={t(errorMessages.gender)}
                  />
                </Grid>
                <Grid md={4} item sm={12} xs={12}>
                  {featureFlagDetails?.DateTimeLocalization === '1' ?
                    <div className={classes.MUIDatePicker}>
                      <RACMUIDatePicker
                        label={t('Date of Birth')}
                        inputProps={{
                          min: '1900-01-01',
                          max: formattedMaxDate,
                        }}
                        name="dateOfBirth"
                        value={identityInformation?.dateOfBirth}
                        onChange={handleDateChange}
                        required={true}
                        errorMessage={t(errorMessages.dateOfBirth)}
                        dateFormat={dateFormat}
                      />
                    </div>
                    : <RACDatePicker
                      label={t('Date of Birth')}
                      inputProps={{
                        min: '1900-01-01',
                        max: formattedMaxDate,
                      }}
                      name="dateOfBirth"
                      value={identityInformation?.dateOfBirth}
                      onChange={handleDateChange}
                      required={true}
                      errorMessage={t(errorMessages.dateOfBirth)}
                      dateFormat={dateFormat}
                    />}

                </Grid>
                <Grid md={4} item sm={12} xs={12}>
                  <RACSelect
                    required={true}
                    inputLabel={t('Marital Status')}
                    options={maritalStatusDropOptions}
                    name="maritalStatus"
                    defaultValue={identityInformation.maritalStatus}
                    onChange={(event) => {
                      handleInputChange(event, 'maritalStatus');
                    }}
                    errorMessage={t(errorMessages.maritalStatus)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: '20px' }}>
                <Grid md={4} item sm={12} xs={12}>
                  {canEnableCountryCode?.paramValue === '1' ?
                    <>
                      <Grid md={12} lg={12} item sm={12} xs={12}>
                        <Typography /* className={classes.fontSize13} */>{t('Phone Number')}<span style={{ color: "red" }}>*</span></Typography>
                      </Grid>
                      <Grid md={12} lg={12} item sm={12} xs={12} style={{ display: 'flex', flexDirection: 'row', width: '100%' }} >
                        <Grid md={3} lg={3} item sm={3} xs={3}>
                          <div className={classes.inputBoxHeightForRACSelect}>
                            <RACSelect
                              inputLabelClassName={classes.fontSize13}
                              defaultValue={identityInformation.countryCode}
                              options={countryCode.map((item: any) => ({
                                label: `+${item.countryCodeValue}`,
                                value: `${item.countryCodeValue}`
                              }))}
                              onChange={(e: React.ChangeEvent<HTMLSelectElement>) => {
                                setIdentityInformation((prev) => ({
                                  ...prev,
                                  countryCode: e.target.value
                                }));
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid md={9} lg={9} item sm={9} xs={9}>
                          <RACTextbox
                            name="phoneNumber"
                            value={formatPhoneNumber(identityInformation?.phoneNumber || '')} // Format for display
                            OnChange={(event) => handleInputChange(event)}
                            errorMessage={t(errorMessages.phoneNumber)}
                            maxlength={14}
                            type='text'
                          />
                        </Grid>
                      </Grid>
                    </>
                    :
                    <RACTextbox
                      inputlabel={t("Phone Number")}
                      name="phoneNumber"
                      value={formatPhoneNumber(identityInformation?.phoneNumber || '')} // Format for display
                      required={true}
                      OnChange={(event) => handleInputChange(event)}
                      errorMessage={t(errorMessages.phoneNumber)}
                      maxlength={18}
                      type='text'
                    />
                  }
                </Grid>
                <Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("Email ID")}
                    name="emailId"
                    value={identityInformation?.emailId}
                    required={true}
                    OnChange={handleInputChange}
                    type='email'
                    errorMessage={t(errorMessages.emailId)}
                  />
                </Grid>
                <Grid md={4} item sm={12} xs={12}>
                  <RACSelect
                    required={true}
                    inputLabelClassName={classes.fontSize13}
                    inputLabel={t('How did you hear about RAC and its promotions?')}
                    options={reorderedOptions}
                    name="racPromotions"
                    defaultValue={identityInformation?.racPromotions}
                    onChange={(event: any) => {
                      handleInputChange(event, 'racPromotions');
                    }}
                    errorMessage={t(errorMessages.racPromotions)}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3} style={{ marginTop: '20px' }}>
                <Grid md={4} item sm={12} xs={12}>
                  <RACTextbox
                    inputlabel={t("RFC")}
                    name="rfc"
                    value={identityInformation?.rfc}
                    required={true}
                    OnChange={handleInputChange}
                    maxlength={13}
                    errorMessage={t(errorMessages.rfc)}
                  />
                </Grid>
                <Grid md={4} item sm={12} xs={12}>
                  <Typography>{t('Choose file option to upload Front page of ID')} <span style={{ color: 'red' }}> *</span></Typography>

                  {showFrontDocument ? (
                    <Grid className={classes.displayFlex}>
                      <Typography
                        className={`${classes.pointer}`}
                        onClick={() => {
                          setOpenFrontDocument(true);
                        }}>

                        <PdfIcon style={{ float: "left", display: 'inline-block', width: 'auto', marginRight: '5px' }}></PdfIcon>
                        {t('Proof of Identity - Front Image.pdf')}

                      </Typography>
                      <Typography
                        component={"label"}
                        className={`${classes.fontPrimaryColor} ${classes.pointer} ${classes.p10px} ${classes.fontOpensansBold} ${classes.font16}`}
                        // className={residenceEditClicked ? `${classes.fontPrimaryColor} ${classes.pointer} ${classes.p10px} ${classes.fontOpensansBold} ${classes.font16}` : `${classes.fontDisabledColor} ${classes.pointer} ${classes.p10px} ${classes.fontOpensansBold} ${classes.font16}`}
                        onClick={() => {
                          setShowFrontDocument(false);
                          setIdentityFrontDocument("");
                          setIsIdentityFrontDocDeleted(true);
                        }}
                      >
                        X
                      </Typography>
                    </Grid>
                  ) : (
                    <RACButton
                      variant="contained"
                      color="primary"
                      id="uploadFrontDocument"
                      onClick={() => {
                        handleButtonClick('F');
                      }}
                      className={`${classes.resUploadImageBtn} ${classes.pointer}`}
                    >
                      {t('Upload')}
                      <input
                        ref={frontFileInputRef}
                        type="file"
                        onChange={(e) => {
                          handleFileChange(e, 'F');
                          e.target.value = '';
                        }}
                        accept=".png,.jpeg,.jpg,.pdf"
                        style={{ display: "none" }}
                      />
                    </RACButton>
                  )}
                </Grid>

                <Grid md={4} item sm={12} xs={12}>
                  <Typography>{t('Choose file option to upload Back page of ID')}  <span style={{ color: 'red' }}> *</span></Typography>

                  {showBackDocument ? (
                    <Grid className={classes.displayFlex}>
                      <Typography
                        className={`${classes.pointer}`}
                        onClick={() => {
                          setOpenBackDocument(true);
                        }}>

                        <PdfIcon style={{ float: "left", display: 'inline-block', width: 'auto', marginRight: '5px' }}></PdfIcon>
                        {t('Proof of Identity - Back Image.pdf')}

                      </Typography>
                      <Typography
                        component={"label"}
                        className={`${classes.fontPrimaryColor} ${classes.pointer} ${classes.p10px} ${classes.fontOpensansBold} ${classes.font16}`}
                        // className={residenceEditClicked ? `${classes.fontPrimaryColor} ${classes.pointer} ${classes.p10px} ${classes.fontOpensansBold} ${classes.font16}` : `${classes.fontDisabledColor} ${classes.pointer} ${classes.p10px} ${classes.fontOpensansBold} ${classes.font16}`}
                        onClick={() => {
                          setShowBackDocument(false);
                          setIdentityBackDocument("");
                          setIsIdentityBackDocDeleted(true);
                        }}
                      >
                        X
                      </Typography>
                    </Grid>
                  ) : (
                    <RACButton
                      variant="contained"
                      color="primary"
                      id="uploadBackDocument"
                      onClick={() => {
                        handleButtonClick('B');
                      }}
                      className={`${classes.resUploadImageBtn} ${classes.pointer}`}
                    >
                      {t('Upload')}
                      <input
                        ref={backFileInputRef}
                        type="file"
                        onChange={(e) => {
                          handleFileChange(e, 'B');
                          e.target.value = '';
                        }}
                        accept=".png,.jpeg,.jpg,.pdf"
                        style={{ display: "none" }}
                      />
                    </RACButton>
                  )}
                </Grid>

              </Grid>
              <RACModalCard
                borderRadius="15px"
                closeIcon={true}
                isOpen={openFrontDocument}
                maxWidth={'sm'}
                className={`${classes.customModal}`}
                title={t(`Proof of Identity - Front`)}
                onClose={() => setOpenFrontDocument(false)}
              >
                {pdfModelContent('F')}
              </RACModalCard>

              <RACModalCard
                borderRadius="15px"
                closeIcon={true}
                isOpen={openBackDocument}
                maxWidth={'sm'}
                className={`${classes.customModal}`}
                title={t(`Proof of Identity - Back`)}
                onClose={() => setOpenBackDocument(false)}
              >
                {pdfModelContent('B')}
              </RACModalCard>

              <Grid style={{ marginTop: '25px', float: 'right' }}>
                <RACButton
                  variant="contained"
                  color="primary"
                  style={{ padding: '12px 40px', borderRadius: '5px' }}
                  onClick={handleNextClick}
                  disabled={!isNextEnabled}
                >
                  {t("Next")}
                </RACButton>
              </Grid>
            </Grid >
          </Grid >
        </>}



    </>
  )

};

export default Identity;